import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex align-end flex-shrink-0 gc-1" },
    [
      _c("div", { staticClass: "text-caption text-secondary--text" }, [
        _vm._v("\n    Эксклюзивно на\n  "),
      ]),
      _vm._v(" "),
      _c(VImg, {
        staticClass: "flex-grow-0",
        attrs: {
          width: "92",
          height: "14",
          contain: "",
          src: "/static/_v1/pd/logos/ui-kit/prodoctorov-logo.svg",
          alt: "Логотип ПроДокторов",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }